// extracted by mini-css-extract-plugin
module.exports = {"root":"intro_root__qSuCp","outer":"intro_outer__24_Yh","inner":"intro_inner__1aH_O","heading":"intro_heading__15vZv","description":"intro_description__2p9GH"};